import { render } from "./MermaList.vue?vue&type=template&id=63a69194&scoped=true"
import script from "./MermaList.vue?vue&type=script&lang=js"
export * from "./MermaList.vue?vue&type=script&lang=js"

import "./MermaList.vue?vue&type=style&index=0&id=63a69194&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a69194"]])

export default __exports__